const { NovelCovid } = require('novelcovid');

const track = new NovelCovid();


export default track;
